module.exports = __webpack_public_path__ + "static/level-10-bg.e5bddc1f.png";